import { useEffect, useRef } from 'react'
import { getPictoByThemeId } from '../../utils/pictos'
import { ADDITIONAL_SALES_HOME_BACKGROUND } from '../../utils/preloadImages'

const themes = {
  BQ: 1,
  CAS: 2,
  ENL: 3,
  MET: 4,
  CATA: 5,
  AC: 6,
  AV: 7,
  MS: 8,
  TT: 9,
  CINE: 10,
  FW: 11,
  MSEC: 12,
}

const AdditionalSalesHome = ({
  onBackgroundReady,
  onThemeClick,
  themesAvailability,
  backgroundSrc = ADDITIONAL_SALES_HOME_BACKGROUND,
}) => {
  const backgroundImageRef = useRef(null)
  const noAvailableThemes =
    Object.values(themesAvailability ?? {}).every((isAvailable) => !isAvailable) &&
    Object.keys(themesAvailability ?? {}).length > 0

  useEffect(() => {
    onBackgroundReady?.()
  }, [onBackgroundReady])

  return (
    <div className="additionalSalesHome hero">
      <div id="header">
        <h3>Psssst</h3>
        <h1>
          {noAvailableThemes ? 'Rien de prévu demain ?' : 'Rien de prévu après ?'}
          <br />
          Parfait.
        </h1>
        <h2>-22€ sur ta prochaine mission</h2>
      </div>
      <div className="themeButtonsWrapper">
        {Object.entries(themes).map(([, themeIndex]) => {
          const Picto = getPictoByThemeId(themeIndex)
          const isAvailable = themesAvailability?.[themeIndex] ?? true

          return (
            <div className="themeGroup" key={themeIndex} onClick={() => onThemeClick?.(themeIndex)}>
              <Picto className={`picto ${isAvailable ? '' : 'disabled'}`}></Picto>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AdditionalSalesHome
